<div class="dialog-container">
  <div class="dialog-header">
    <div class="user-edit-icon">
      <img src="assets/images/health/homeimg/exandcareplan/add_diet.png" class="add-icon" alt="User Icon" />
    </div>
    <div class="header-text">
        <h2 class="addmed">{{ mode === 'add' ? 'Add Diet' : 'Edit Diet' }}</h2>
      </div>
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
   <div class="dialog-content">
    <form [formGroup]="nutritionForm" (ngSubmit)="onSave()" class="form-dialog">
        <div formArrayName="nutrients" class="nutrient-grid">
            <ng-container class="nutrient-input"
        *ngFor="let item of nutrients.controls; let i = index"
        [formGroupName]="i">
            <div class="nutrient-input">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ item.value.name }} {{ item.value.qty }} {{ item.value.valueUnit }}</mat-label>
                  <input matInput type="number" pattern="^[0-9]*$" min="0" max="999999" formControlName="value" [placeholder]="'Enter a value (e.g. ' + item.value.qty +  ')'"/>
                </mat-form-field>
                
            </div>
            </ng-container>
        </div>

        <div class="meal-selection">
            <div
            *ngFor="let meal of mealTypes"
            class="meal-option"
            [class.selected]="selectedMeal === meal.key"
            (click)="selectMeal(meal)"
            >
            <img [src]="meal.icon" alt="{{ meal.label }}" width="32" height="32" />
            <div>{{ meal.label }}</div>
            </div>
        </div>

        <div class="datetime-row">
            <mat-form-field appearance="outline">
            <mat-label>Date</mat-label>
            <input [max]="today" readonly matInput [matDatepicker]="picker" formControlName="date" (focus)="picker.open()" (click)="picker.open()"/>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
            <mat-label>Time</mat-label>
            <input matInput type="time" formControlName="time" />
            </mat-form-field>
        </div>
    </form>

   </div>
   <!-- Action Buttons -->
    <div class="dialog-actions">
      <button mat-stroked-button color="primary" (click)="onCancel()">Cancel</button>
      <button mat-flat-button color="primary" (click)="onSave()">Save</button>
    </div>

  
</div>
